/* eslint-disable */
/* tslint:disable */
/* auto-generated vue proxies */
import { defineContainer } from './vue-component-lib/utils';

import type { JSX } from '@ovhcloud/ods-stencil/components/range/custom-elements';

import { defineCustomElement as defineOsdsRange } from '@ovhcloud/ods-stencil/components/range/custom-elements/osds-range.js';


export const OsdsRange = /*@__PURE__*/ defineContainer<JSX.OsdsRange>('osds-range', defineOsdsRange, [
  'color',
  'disabled',
  'flex',
  'max',
  'min',
  'step',
  'value',
  'formControl',
  'errorStateControl',
  'error',
  'forbiddenValues',
  'odsValueChange'
]);

